import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import html2canvas from 'html2canvas';

export interface Charting {
    showDataPointsOnChart(chart);
}

export class Charting {
  
    //savingChartInProgress: boolean = false;

    constructor() {}


    showDataPointsOnChart(chart) {
    let index = 0;
    const paths = chart.chartElement.nativeElement.getElementsByClassName(
        'line-series'
    );
    const color = chart.chartElement.nativeElement.getElementsByClassName(
        'line-highlight'
    );

    for (let path of paths) {
        const chrtColor = color[index].getAttribute('ng-reflect-fill');
        const pathElement = path.getElementsByTagName('path')[0];
        const pathAttributes = {
            'marker-start': `url(#dot${index})`,
            'marker-mid': `url(#dot${index})`,
            'marker-end': `url(#dot${index})`
        };
        this.createMarker(chart, chrtColor, index);
        this.setAttributes(pathElement, pathAttributes);
        index += 1;
    }
    }


    createMarker(chart, color, index) {
    const svg = chart.chartElement.nativeElement.getElementsByTagName('svg');
    var marker = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'marker'
    );
    var circle = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'circle'
    );
    svg[0].getElementsByTagName('defs')[0].append(marker);
    marker.append(circle);
    const m = svg[0].getElementsByTagName('marker')[index];
    const c = svg[0].getElementsByTagName('circle')[index];

    const markerAttributes = {
        id: `dot${index}`,
        viewBox: '0 0 10 10',
        refX: 5,
        refY: 5,
        markerWidth: 5,
        markerHeight: 5
    };

    const circleAttributes = {
        cx: 5,
        cy: 5,
        r: 5,
        fill: color
    };
    m.append(circle);

    this.setAttributes(m, markerAttributes);
    this.setAttributes(c, circleAttributes);
    }


    setAttributes(element, attributes) {
        for (const key in attributes) {
            element.setAttribute(key, attributes[key]);
        }
    }


    saveChartAsImage(elementId: string, filename: string): void {
        //this.savingChartInProgress = true;
       const chartElement = document.getElementById(elementId);
        if (chartElement) {
          html2canvas(chartElement, {
            backgroundColor: '#ffffff'
          }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            link.download = filename + '.jpg';
            link.href = imgData;
            link.click();
          });
        }
        //this.savingChartInProgress = false;
    }


}